import React, { useEffect, useState } from "react";
import "./BankDetails.css";

const BankDetails = ({ bankDetails, saving, onSave }) => {
  const [formData, setFormData] = useState({
    accountHolder: "",
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    upiId: "",
    accountType: "Savings",
  });

  useEffect(() => {
    if (bankDetails) {
      setFormData({
        accountHolder: bankDetails.accountHolder || "",
        bankName: bankDetails.bankName || "",
        accountNumber: bankDetails.accountNumber || "",
        ifscCode: bankDetails.ifscCode || "",
        upiId: bankDetails.upiId || "",
        accountType: bankDetails.accountType || "Savings",
      });
    }
  }, [bankDetails]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const submitHandler = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="bank-card">

      <div className="card-header">
        <div>
          <h3>🏦 Bank Details</h3>
          <p>
            Manage your bank account for payouts and settlements.
          </p>
        </div>

        <span className="verified-badge">
          ✓ Secure
        </span>
      </div>

      <form onSubmit={submitHandler}>

        <div className="bank-grid">

          <div className="bank-group">
            <label>Account Holder Name</label>
            <input
              type="text"
              name="accountHolder"
              placeholder="Enter account holder name"
              value={formData.accountHolder}
              onChange={handleChange}
            />
          </div>

          <div className="bank-group">
            <label>Bank Name</label>
            <input
              type="text"
              name="bankName"
              placeholder="Enter bank name"
              value={formData.bankName}
              onChange={handleChange}
            />
          </div>

          <div className="bank-group">
            <label>Account Number</label>
            <input
              type="text"
              name="accountNumber"
              placeholder="Enter account number"
              value={formData.accountNumber}
              onChange={handleChange}
            />
          </div>

          <div className="bank-group">
            <label>IFSC Code</label>
            <input
              type="text"
              name="ifscCode"
              placeholder="SBIN0001234"
              value={formData.ifscCode}
              onChange={handleChange}
            />
          </div>

          <div className="bank-group">
            <label>UPI ID</label>
            <input
              type="text"
              name="upiId"
              placeholder="example@upi"
              value={formData.upiId}
              onChange={handleChange}
            />
          </div>

          <div className="bank-group">
            <label>Account Type</label>

            <select
              name="accountType"
              value={formData.accountType}
              onChange={handleChange}
            >
              <option value="Savings">
                Savings Account
              </option>

              <option value="Current">
                Current Account
              </option>
            </select>

          </div>

        </div>

        <div className="bank-info">

          <div className="info-box">
            🔒 Your banking information is encrypted and securely stored.
          </div>

          <button
            type="submit"
            className="bank-btn"
            disabled={saving}
          >
            {saving ? "Saving..." : "Save Bank Details"}
          </button>

        </div>

      </form>

    </div>
  );
};

export default BankDetails;